import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n/config";
import { installClickTracking } from "./lib/trackClicks";

if (typeof window !== "undefined" && !window.location.pathname.startsWith("/admin")) {
  installClickTracking();
}

createRoot(document.getElementById("root")!).render(<App />);
